import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import Irmao from '@/../common/types/Irmao'
import IrmaoService from '@/services/IrmaoService'
import ComponentAuthGuard from '@/components/ComponentAuthGuard.vue'
import { adminIrmaoGuard as guardaDeAdminDoIrmao } from '@/shareds/sharedsIrmao'
import { getErrorMessage } from '@/helpers/error-helpers'
import CabecalhoDeDetalhesDoIrmao from './components/CabecalhoDeDetalhesDoIrmao.vue'
import AbaGeralDoIrmao from './components/AbaGeralDoIrmao.vue'
import AbaPessoalDoIrmao from './components/AbaPessoalDoIrmao.vue'
import AbaDeServicosDoIrmao from './components/AbaDeServicosDoIrmao.vue'
import AbaDeCertificadosDoIrmao from './components/AbaDeCertificadosDoIrmao.vue'
import { useRoute, useRouter } from '@/composables/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'DetalharIrmao',
  props: {
	id: { type: String, required: true },
},
  setup(__props) {

const props = __props;



const router = useRouter()
const route = useRoute()

const carregando = ref(true)
const erro = ref<string | undefined>(undefined)
const irmao = ref<Irmao | null>(null)
const tabs = ['Geral', 'Serviços', 'Certificados']

async function buscarIrmao() {
	carregando.value = true
	erro.value = undefined
	try {
		irmao.value = await IrmaoService.get(props.id)
	} catch (error) {
		erro.value = getErrorMessage(error)
	} finally {
		carregando.value = false
	}
}

buscarIrmao()

const adminIrmaoGuard = computed(() => {
	if (!irmao.value) return () => false
	return guardaDeAdminDoIrmao(irmao.value)
})

const tab = computed({
	get: () => typeof route.query.t === 'string' ? route.query.t : 'Geral',
	set: (novaTab: string) => {
		router.replace({
			name: 'detalhar-irmao',
			params: { id: props.id },
			query: { t: novaTab },
		})
	},
})

return { __sfc: true,props, router, route, carregando, erro, irmao, tabs, buscarIrmao, adminIrmaoGuard, tab, ComponentAuthGuard, CabecalhoDeDetalhesDoIrmao, AbaGeralDoIrmao, AbaPessoalDoIrmao, AbaDeServicosDoIrmao, AbaDeCertificadosDoIrmao }
}

})